import { DO_LOGIN, DO_LOGIN_SUCCESS, DO_LOGIN_FAILURE, DO_LOGOUT } from '../actions/Auth'

const initialState = {
  user: null,
  error: null,
  loading: false,
  valid: false
}

export default function auth (state = initialState, action) {
  switch (action.type) {
    case DO_LOGIN:
      return { ...state, loading: true, error: null, valid: false }
    case DO_LOGIN_SUCCESS:
      window.localStorage.setItem('it.clubhub.email', action.payload.email)
      window.localStorage.setItem('it.clubhub.bearer', action.payload.bearer)
      window.localStorage.setItem('it.clubhub.time', action.payload.time)
      window.localStorage.setItem('it.clubhub.grant', action.payload.grant)
      window.localStorage.setItem('it.clubhub.club', action.payload.club)
      window.localStorage.setItem('it.clubhub.userid', action.payload.userid)
      window.localStorage.setItem('it.clubhub.fiscalyear', action.payload.fiscalyear)
      return { ...state, user: action.payload, loading: false, valid: true, error: null }
    case DO_LOGIN_FAILURE:
      return { ...state, error: action.payload, loading: false, valid: false }
    case DO_LOGOUT:
      window.localStorage.removeItem('it.clubhub.email')
      window.localStorage.removeItem('it.clubhub.bearer')
      window.localStorage.removeItem('it.clubhub.time')
      window.localStorage.removeItem('it.clubhub.grant')
      window.localStorage.removeItem('it.clubhub.club')
      window.localStorage.removeItem('it.clubhub.userid')
      window.localStorage.removeItem('it.clubhub.fiscalyear')
      window.localStorage.clear()
      return { ...state, error: null, loading: false, valid: false, user: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js